var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import React, { useEffect } from 'react';
import { observer } from 'mobx-react-lite';
import { useTranslation } from 'react-i18next';
import classNames from 'classnames';
import { useLoader } from 'ziphy-web-shared/basic/hooks';
import { WithLoaderWrapper } from 'ziphy-web-shared/basic/lib/loaders';
import styles from './Notes.module.scss';
import { $notes } from './Notes.store';
import Section from './section/Section';
import SectionAddAddendum from './section/sectionAddAddendum/SectionAddAddendum';
import SectionAddendum from './section/sectionAddendum/SectionAddendum';
import SectionSign from './section/sectionSign/SectionSign';
import Sidebar from './ui/sidebar/Sidebar';
import SidebarContent from './ui/sidebarContent/SidebarContent';
import TopBar from './ui/topBar/TopBar';
const Notes = ({ practice, appointment, encounter, patient, isStartProvider, isLoading: isApptLoading, }) => {
    const { t } = useTranslation();
    const { isLoading } = useLoader(() => __awaiter(void 0, void 0, void 0, function* () {
        if (!encounter || isApptLoading)
            return;
        yield $notes.open({ practice, appointment, encounter, patient, isStartProvider });
    }), [
        encounter === null || encounter === void 0 ? void 0 : encounter.id,
        encounter === null || encounter === void 0 ? void 0 : encounter.startTime,
        encounter === null || encounter === void 0 ? void 0 : encounter.cancelTime,
        encounter === null || encounter === void 0 ? void 0 : encounter.finishTime,
        isApptLoading,
    ]);
    useEffect(() => {
        if (isLoading)
            return;
        $notes.UPDATE_CONTEXT({ practice, appointment, encounter, patient, isStartProvider });
    }, [encounter, appointment, patient]);
    useEffect(() => () => $notes.clear(true), []);
    return (_jsx(WithLoaderWrapper, Object.assign({ id: 'notes_wrapper', isLoading: isLoading, loader: isApptLoading ? _jsx(_Fragment, {}) : undefined, className: styles.wrapper }, { children: _jsx("div", Object.assign({ className: classNames(styles.container, 'container') }, { children: $notes.encounter ? (_jsxs(_Fragment, { children: [_jsxs("div", Object.assign({ className: styles.inner }, { children: [_jsx(TopBar, { className: classNames(styles.topBar, 'mb-20') }), _jsxs("div", Object.assign({ className: styles.content }, { children: [_jsxs("div", Object.assign({ className: styles.sections }, { children: [$notes.sections.map(($section) => (_jsx(Section, { "$section": $section }, $section.id))), $notes.addendum.length > 0 && _jsx(SectionAddendum, { data: $notes.addendum }), ($notes.isEditable || $notes.isSigned) && _jsx(SectionSign, {}), $notes.isLocked && $notes.encounterStatus.isFinished && _jsx(SectionAddAddendum, {})] })), _jsx(SidebarContent, { className: styles.sidebarContent })] }))] })), _jsx(Sidebar, { className: styles.sidebar })] })) : (!isApptLoading &&
                ($notes.openError ? (_jsx("div", Object.assign({ className: styles.noResults }, { children: t('error.something_went_wrong_try_again_later') }))) : (_jsx("div", Object.assign({ className: styles.noResults }, { children: t('text.appt_no_encounters') }))))) })) })));
};
export default observer(Notes);
